import { ErrorText, FieldLabel } from '../';
import './InputField.scss';

interface Props {
  label: string;
  placeholder: string;
  value: string;
  isInError?: boolean;
  errorText?: string;
  onChange: (newValue: string) => void;
}

export default function InputField({
  label,
  placeholder,
  value,
  isInError,
  errorText,
  onChange,
}: Props) {
  return (
    <div className='InputField'>
      <FieldLabel
        text={label}
      />
      <input
        className='Input'
        placeholder={placeholder}
        maxLength={50}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      {
        errorText && isInError && (
          <ErrorText
            text={errorText}
            isActive={isInError}
          />
        )
      }
    </div>
  );
}
